import { render, staticRenderFns } from "./EnvelopeDetails.vue?vue&type=template&id=e64da794&scoped=true"
import script from "./EnvelopeDetails.vue?vue&type=script&lang=js"
export * from "./EnvelopeDetails.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeDetails.vue?vue&type=style&index=0&id=e64da794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64da794",
  null
  
)

export default component.exports